import { useCallback, useState } from 'react';

import {
  Query,
  useNewWsStoreIs,
  NewAccountChannelRequest,
} from '@/true-fsd/data/advertiser-account';

import { AwaitNewChannelFormProps } from './shared/AwaitNewChannelForm';

export const useCreateAccountWithChannel = () => {
  const [channelRequest, setChannelRequest] =
    useState<NewAccountChannelRequest | null>(null);

  const onCancel = useCallback(() => setChannelRequest(null), []);

  const newAccount = useNewWsStoreIs((state) => state.newAccount);

  const { mutateAsync } = Query.usePutNewAccountChannelRequest();

  const mutateAsyncChannel: AwaitNewChannelFormProps['mutateAsync'] =
    useCallback(
      ({ channel, onError }) =>
        mutateAsync(
          { channel, account: newAccount },
          {
            onError,
            onSuccess(data) {
              setChannelRequest(data);
            },
          },
        ),
      [mutateAsync, newAccount],
    );

  return {
    channelRequest,
    onCancel,
    mutateAsyncChannel,
  };
};
export type UseCreateAccountWithChannel = ReturnType<
  typeof useCreateAccountWithChannel
>;
